import { Box, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import api from "../../services/api";
import TaskViews from "../KeyComponents/TaskViews";
import usePageViewMode from "../../utils/usePageViewMode";
import usePagePref from "../../utils/usePagePref";
import { DEFAULT_TABLE_COLUMNS } from "../../utils/tableColumns";
import { useView } from "../../utils/PersonalViewProvider";
import { useWorkspace } from "../../utils/WorkspaceContext";

const CoreTask = () => {
  const [projects, setProjects] = useState([]);
  const { selectedAssignee } = useView();
  const { currentWorkspace } = useWorkspace();
  const [loading, setLoading] = useState(true);

  const listViewRef = useRef();
  const pageId = "core-task-view";
  const [viewMode, setViewMode] = usePageViewMode(pageId, "list");
  const [sortCriteria, setSortCriteria] = usePagePref(pageId, "sort", []);
  const [visibleCols, setVisibleCols] = usePagePref(
    pageId,
    "columns",
    DEFAULT_TABLE_COLUMNS,
  );

  useEffect(() => {
    fetchProjects().then((data) => {
      setProjects(data || []);
      setLoading(false);
    });
  }, [currentWorkspace, selectedAssignee, viewMode]);

  const fetchProjects = async () => {
    try {
      const params = {
        workspace_id: currentWorkspace?.id,
      };

      if (selectedAssignee) {
        params.assignee = selectedAssignee;
      }
      if (viewMode === "table") params.table = "true";

      const response = await api.get("core-tasks/", { params });
      const data = await response.data.payload;
      return data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      return [];
    }
  };

  const handleExpandAll = () => listViewRef.current?.expandAll();
  const handleCollapseAll = () => listViewRef.current?.collapseAll();

  if (loading) return <div>Loading...</div>;

  return (
    <Box sx={{ padding: 1 }}>
      <TaskViews
        projects={projects}
        fetchProjects={fetchProjects}
        setProjects={setProjects}
        pageId={pageId}
        listViewRef={listViewRef}
        viewMode={viewMode}
        setViewMode={setViewMode}
        sortCriteria={sortCriteria}
        setSortCriteria={setSortCriteria}
        visibleCols={visibleCols}
        setVisibleCols={setVisibleCols}
        leftExtras={
          viewMode === "list" ? (
            <Box sx={{ display: "flex", gap: 1, mr: 1 }}>
              <Button variant="outlined" onClick={handleExpandAll}>
                Expand All
              </Button>
              <Button variant="outlined" onClick={handleCollapseAll}>
                Collapse All
              </Button>
            </Box>
          ) : null
        }
      />
    </Box>
  );
};

export default CoreTask;
